import { resolveImageAlt } from "../../lib/imageAlt";

export default function MarkdownImage({ src, alt, ...props }) {
	const resolvedAlt = resolveImageAlt({
		src,
		// Markdown ![](...) always arrives as alt="".
		// Treat that legacy empty value as "not provided" so a useful filename
		// can supply the fallback. Technical/generic filenames still resolve to "".
		alt: alt === "" ? undefined : alt,
	});

	return <img {...props} src={src} alt={resolvedAlt} />;
}
